import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import {
  CheckoutBankComponent,
  CheckoutBankEditComponent,
  CheckoutBankNewComponent,
  CheckoutBankUserEditComponent,
  CheckoutBankUserNewComponent,
  CheckoutGatewayComponent,
  CheckoutGatewayEditComponent,
  CheckoutGatewayNewComponent,
  CheckoutProcessorComponent,
  CheckoutProcessorEditComponent,
  CheckoutProcessorNewComponent,
  CheckoutProcessorUserEditComponent,
  CheckoutProcessorUserNewComponent,
  CheckoutProfileUserComponent,
  ProcessorDocumentPopupComponent,
  CheckoutsComponent,
  CheckoutTemplatesComponent,
  CheckoutTemplateDetailsComponent,
  CheckoutBuilderComponent,
  CheckoutPopupComponent,
  UpsellPopupComponent,
  CheckoutMerchantPopupComponent,
  GatewayTransactionSummaryComponent,
  GatewayTransactionDetailComponent,
  ProcessorConfigFieldsComponent,
} from '.';
import { MicroformDocsComponent } from './microform-docs/microform-docs.component';
import { CheckoutsRoutingModule } from './checkouts.routing';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditorModule } from '@tinymce/tinymce-angular';
import { SharedModule } from '../_shared/shared.module';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MatExpansionModule, MatTreeModule } from '@angular/material';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';

@NgModule({
  declarations: [
    CheckoutsComponent,
    CheckoutTemplatesComponent,
    CheckoutTemplateDetailsComponent,
    CheckoutBuilderComponent,
    CheckoutPopupComponent,
    UpsellPopupComponent,
    CheckoutMerchantPopupComponent,
    CheckoutGatewayComponent,
    CheckoutGatewayNewComponent,
    CheckoutGatewayEditComponent,
    ProcessorConfigFieldsComponent,
    CheckoutBankComponent,
    CheckoutBankEditComponent,
    CheckoutBankNewComponent,
    CheckoutBankUserNewComponent,
    CheckoutBankUserEditComponent,
    CheckoutProcessorComponent,
    CheckoutProcessorEditComponent,
    CheckoutProcessorNewComponent,
    CheckoutProcessorUserEditComponent,
    CheckoutProcessorUserNewComponent,
    ProcessorDocumentPopupComponent,
    CheckoutProfileUserComponent,
    GatewayTransactionSummaryComponent,
    GatewayTransactionDetailComponent,
    MicroformDocsComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    CheckoutsRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    EditorModule,
    SharedModule,
    NgbModule,
    MatExpansionModule,
    MatTreeModule,
    NgxSmartModalModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    NgxDaterangepickerMd.forRoot(),
  ],
  // Exported for the merchant profile form (root module), which reuses the processor config fields
  exports: [ProcessorConfigFieldsComponent],
  providers: [],
  bootstrap: [],
})
export class CheckoutsModule {}
